// removed by extract-text-webpack-plugin
module.exports = {"player-name":"Zf46VGLotjUZqRBhTry3-_0","card-box":"_2SokrAz2p4IbZxq-LgBv1I_0","active":"_3nXYRFF00wBHBwJ7Cl2dIG_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ecc9999","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/game-states/LEGISLATING/president-policies.vue
// module id = 212
// module chunks = 0